"use strict";
// generated-supplemental-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
});
exports.nodeType = 'file_generatedSupplementalTape';
exports.artifactType = 'generatedSupplementalTape';
//# sourceMappingURL=types.js.map